export const tickerItems = [
  "分站内容划分已整理成一页导览，先看再选不再来回翻",
  "主站与分站的更新节奏差异，新增一栏对照说明",
  "独立版块的玩法差异补齐了 6 个专属区块",
  "话题墙新增一批标签，按方向聚合更方便判断",
  "常见问题区补充了「该从哪个分站开始看」的说明",
  "分站特色清单已按内容方向重新分组",
];

export const navLinks = [
  { label: "分站入口", href: "#entry" },
  { label: "区别对比", href: "#compare" },
  { label: "话题墙", href: "#topics" },
  { label: "独立版块", href: "#blocks" },
  { label: "常见问题", href: "#faq" },
];

export const heroStats = [
  { value: "6", label: "内容方向入口" },
  { value: "18", label: "分站特色条目" },
  { value: "5", label: "对比维度" },
  { value: "36", label: "话题标签" },
];

export const entries = [
  {
    icon: "ri-flashlight-line",
    name: "更新速览",
    desc: "只看当天与近几日的更新流向，适合先判断今天值不值得停下来看。",
    meta: "高频更新",
    tone: "primary",
  },
  {
    icon: "ri-stack-line",
    name: "内容划分",
    desc: "按方向把各分站的内容归好类，一眼看清哪块讲什么，不用逐条翻。",
    meta: "结构导览",
    tone: "secondary",
  },
  {
    icon: "ri-contrast-2-line",
    name: "主站对照",
    desc: "把主站与分站的定位并排摆放，区别和不同都写在明面上。",
    meta: "差异对照",
    tone: "accent",
  },
  {
    icon: "ri-price-tag-3-line",
    name: "话题聚合",
    desc: "用标签把零散内容串起来，顺着一个话题就能追完整条线。",
    meta: "标签驱动",
    tone: "secondary",
  },
  {
    icon: "ri-layout-grid-line",
    name: "独立版块",
    desc: "分站里单独成型的专属区块，各有各的玩法和浏览顺序。",
    meta: "专属区块",
    tone: "accent",
  },
  {
    icon: "ri-question-answer-line",
    name: "新手说明",
    desc: "第一次来先看这里，把「先去哪、怎么选」讲清楚再开始浏览。",
    meta: "入门向",
    tone: "primary",
  },
];

export const compareDimensions = [
  {
    dimension: "内容划分",
    main: "主站把各方向混在一个信息流里，靠标题区分。",
    branch: "分站按方向切开，每一块只讲自己的题材，边界清楚。",
  },
  {
    dimension: "更新节奏",
    main: "整体更新集中，峰值时段内容量偏大。",
    branch: "各分站错峰更新，节奏不同，能挑自己习惯的时间看。",
  },
  {
    dimension: "板块玩法",
    main: "以连续浏览为主，一条接一条往前推。",
    branch: "专属版块有各自的组织方式，可回看、可对照、可按标签追。",
  },
  {
    dimension: "浏览入口",
    main: "从首页信息流进入，适合随手刷。",
    branch: "从入口条和标签墙进入，适合带着目标去找。",
  },
  {
    dimension: "适合人群",
    main: "没有明确目标、想先随便看看的浏览者。",
    branch: "已经知道自己想追哪个方向、想少绕弯的浏览者。",
  },
];

export const tags = [
  "更新速览",
  "内容划分",
  "主站对照",
  "分站特色",
  "板块差异",
  "专属区块",
  "独立玩法",
  "话题聚合",
  "标签导航",
  "新手入门",
  "浏览顺序",
  "错峰更新",
  "方向索引",
  "图文专栏",
  "时间线回看",
  "对照实验室",
  "内容边界",
  "节奏差异",
  "入口条",
  "更新条",
  "导览页",
  "分站说明",
  "玩法拆解",
  "选题方向",
  "长期跟踪",
  "回看清单",
  "聚合面板",
  "结构地图",
  "筛选维度",
  "取舍建议",
  "先看什么",
  "省时浏览",
  "对比维度",
  "分站地图",
  "一眼看懂",
  "方向标签",
];

export const exclusiveBlocks = [
  {
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20stylized%20illustration%20of%20a%20stack%20of%20glowing%20news%20snapshot%20frames%20on%20a%20warm%20ivory%20background%20with%20amber%20highlights%2C%20flat%20geometric%20editorial%20style%2C%20soft%20shadows%2C%20no%20text&width=900&height=700&seq=hla5-block-update&orientation=landscape",
    name: "更新速览面板",
    tag: "专属板块",
    desc: "把当天与近几日的更新单独拉出来，按时间排好，适合只想快速扫一眼的人。",
    points: ["只保留近期", "按时间排列", "一眼扫完"],
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20scattered%20tag%20chips%20and%20speech%20bubbles%20gathering%20around%20a%20center%20point%2C%20warm%20cream%20backdrop%2C%20olive%20green%20and%20amber%20palette%2C%20flat%20minimal%20editorial%20style%2C%20no%20text&width=900&height=700&seq=hla5-block-topics&orientation=landscape",
    name: "话题聚合栏",
    tag: "专属板块",
    desc: "围绕一个标签把散落的内容收拢，顺着话题往下看，比盲目翻页更有方向。",
    points: ["标签驱动", "话题串联", "可延展"],
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20abstract%20illustration%20of%20two%20balanced%20columns%20being%20compared%20with%20slender%20measuring%20lines%2C%20warm%20sand%20background%2C%20amber%20and%20olive%20tones%2C%20editorial%20geometry%2C%20no%20text&width=900&height=700&seq=hla5-block-compare&orientation=landscape",
    name: "对照实验室",
    tag: "专属板块",
    desc: "把主站和分站并排放，用统一的维度逐条比，区别在哪不用自己猜。",
    points: ["并排对照", "维度统一", "差异直给"],
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20minimal%20illustration%20of%20a%20horizontal%20timeline%20with%20dots%20and%20small%20cards%2C%20warm%20ivory%20background%2C%20soft%20amber%20gradient%20accents%2C%20clean%20editorial%20style%2C%20no%20text&width=900&height=700&seq=hla5-block-timeline&orientation=landscape",
    name: "时间线回看",
    tag: "专属板块",
    desc: "按时间轴往回翻，把错过的部分补上，适合隔几天才来一次的人。",
    points: ["按轴回看", "补看方便", "不打断"],
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20stylized%20illustration%20of%20overlapping%20magazine%20pages%20and%20image%20frames%2C%20warm%20cream%20background%2C%20olive%20and%20amber%20accents%2C%20flat%20editorial%20composition%2C%20no%20text&width=900&height=700&seq=hla5-block-column&orientation=landscape",
    name: "图文专栏位",
    tag: "专属板块",
    desc: "以图配文的形式整理一个方向，看图看字都不费劲，适合慢慢读。",
    points: ["图文并重", "成篇阅读", "节奏舒缓"],
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20a%20modular%20grid%20of%20small%20panels%20in%20varied%20warm%20tones%2C%20cream%20background%2C%20amber%20olive%20taupe%20palette%2C%20minimal%20editorial%20style%2C%20no%20text&width=900&height=700&seq=hla5-block-grid&orientation=landscape",
    name: "独立板块墙",
    tag: "专属板块",
    desc: "所有独立成型的小版块集中在一面墙上，挑一块进去，各自互不打扰。",
    points: ["互不干扰", "自由挑选", "结构清晰"],
  },
];

export const trustStats = [
  { value: "100%", label: "静态导览，无需登录即可浏览" },
  { value: "5", label: "公开对照维度，差异不藏着" },
  { value: "6", label: "专属板块，玩法各自独立" },
  { value: "1", label: "单页看完全貌，不用来回跳转" },
];

export const trustPoints = [
  {
    icon: "ri-eye-line",
    title: "结构公开",
    desc: "内容怎么分、分站怎么摆，全写在页面上，不靠猜也不靠试。",
  },
  {
    icon: "ri-scales-3-line",
    title: "对照统一",
    desc: "所有区别都用同一套维度比较，结论能横向对齐，不会各说各话。",
  },
  {
    icon: "ri-shield-check-line",
    title: "浏览轻量",
    desc: "页面只做导览与说明，不打扰阅读，打开就能安静地判断方向。",
  },
];

export const faqs = [
  {
    q: "黑料网5 的分站和主站到底差在哪？",
    a: "主要差别在内容划分和组织方式。主站把所有方向放在同一条信息流里，靠标题分辨；分站则按方向切开，每一块只讲自己的题材，边界更清楚，也更容易判断哪块适合自己。",
  },
  {
    q: "第一次来，应该先看哪个分站？",
    a: "建议先看「内容划分」和「主站对照」两栏，用几分钟了解各方向讲什么；如果心里已经有想追的方向，直接从对应的分站入口进去即可，不必从主站开始逐条翻。",
  },
  {
    q: "什么是黑料网5 的独立版块？",
    a: "独立版块是分站里单独成型的专属区块，例如更新速览面板、话题聚合栏、对照实验室等。它们各自有固定的组织方式和浏览顺序，互不干扰，可以按需挑一块进去。",
  },
  {
    q: "各分站的更新节奏一样吗？",
    a: "不一样。分站采用错峰更新的方式，不同方向的高峰时段不同。如果你习惯在固定时间浏览，可以先对照节奏差异，选一个更新时间更贴合自己作息的板块。",
  },
  {
    q: "标签墙应该怎么用？",
    a: "标签墙是把零散内容串成线的入口。点开一个标签，就能看到同一话题下的内容集合，适合已经有明确兴趣点、想少绕弯的浏览者。",
  },
  {
    q: "页面上的按钮和搜索框能做什么？",
    a: "当前首页是静态导览页，按钮与搜索框用于演示交互与结构，帮助你先理解各分站的布局与差异，方便日后按方向快速定位。",
  },
];